import {StoreIssueItems} from './store-issue-items';
export class StoreIssues{
    storeConsumptionCode:string;
    saleOrderId:number;
    customer:string;
    consumedDate:Date;
    indentDate:Date;
    indentNo:string;
    StoreIssueItems:StoreIssueItems[];
}